import { render, staticRenderFns } from "./loginMs.vue?vue&type=template&id=260331e6&scoped=true&"
import script from "./loginMs.vue?vue&type=script&lang=js&"
export * from "./loginMs.vue?vue&type=script&lang=js&"
import style0 from "./loginMs.vue?vue&type=style&index=0&id=260331e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260331e6",
  null
  
)

export default component.exports